import { render } from "./CxHeader.vue?vue&type=template&id=e8db830a"
import script from "./CxHeader.vue?vue&type=script&lang=js"
export * from "./CxHeader.vue?vue&type=script&lang=js"

import "./CxHeader.vue?vue&type=style&index=0&id=e8db830a&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__